import AssignmentStateProto from 'goog:proto.omaha.api.classroom.AssignmentState';

/**
 * Provides the current environment and LMS
 */

export enum Environment {
  SPOTCHECK = 'spotcheck',
  LTI = 'lti',
  AUTHORING = 'authoring',
  ASSIGNMENT_ASSEMBLY = 'assembly',
  ADD_QUESTIONS = 'add_questions',
  PASSAGE_LIBRARY = 'passage_library',
}

export enum LMS {
  CANVAS = 'canvas',
  GOOGLE_CLASSROOM = 'google_classroom',
  OTHER_LMS = 'other_lms',
  NO_LMS = 'no_lms',
}

// Maps proto classroom.LMS enum values to the environment LMS enum.
// Proto values: GOOGLE_CLASSROOM=1, CANVAS=2.
const PROTO_LMS_MAP: Record<number, LMS> = {
  1: LMS.GOOGLE_CLASSROOM,
  2: LMS.CANVAS,
};

export function lmsFromProto(assignment: AssignmentStateProto | null): LMS {
  const protoLms = assignment?.getAssignmentLms();
  if (protoLms !== undefined && protoLms in PROTO_LMS_MAP) {
    return PROTO_LMS_MAP[protoLms];
  } else if (assignment?.getIsCanvas()) {
    return LMS.CANVAS;
  } else {
    return LMS.OTHER_LMS;
  }
}
export interface DerivitaEnvironment {
  sessionId?: string;
  storagePath?: string;
  lms?: LMS;
  environment?: Environment;
  supportURL?: URL;
  setupNewTab?: (
    fbConfig: string,
    assignmentData: string,
    autoEnterFocus?: boolean
  ) => void;
}

export class EnvironmentService {
  private environment_?: Environment;
  private lms_: LMS;
  private supportURL_?: URL;

  constructor(opts: DerivitaEnvironment) {
    this.environment_ = opts.environment;
    this.lms_ = opts.lms ?? LMS.NO_LMS;
    this.supportURL_ = opts.supportURL;
  }

  getEnvironment(): Environment | undefined {
    return this.environment_;
  }

  getLMS(): LMS {
    return this.lms_;
  }

  getSupportURL(): URL | undefined {
    return this.supportURL_;
  }
}

// TODO: Move this to a better location and/or get rid of it.
export function isInDevQABetaSpotcheck(hostname: string): boolean {
  return (
    hostname.includes('localhost') ||
    hostname.includes('qa.rs.pn') ||
    hostname.includes('beta-dot-derivita')
  );
}

export function isInDev(): boolean {
  return window.location.hostname.includes('localhost');
}
